/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  JudgeConfiguration,
  JudgeConfiguration$inboundSchema,
  JudgeConfiguration$Outbound,
  JudgeConfiguration$outboundSchema,
} from "./judgeconfiguration.js";
import {
  Message,
  Message$inboundSchema,
  Message$Outbound,
  Message$outboundSchema,
} from "./message.js";
import {
  VariationToolPost,
  VariationToolPost$inboundSchema,
  VariationToolPost$Outbound,
  VariationToolPost$outboundSchema,
} from "./variationtoolpost.js";

export type AIConfigVariationPostModel = {};

export type AIConfigVariationPost = {
  /**
   * Human-readable description of this variation
   */
  comment?: string | undefined;
  /**
   * Returns the description for the agent. This is only returned for agent variations.
   */
  description?: string | undefined;
  /**
   * Returns the instructions for the agent. This is only returned for agent variations.
   */
  instructions?: string | undefined;
  key: string;
  messages?: Array<Message> | undefined;
  model?: AIConfigVariationPostModel | undefined;
  name: string;
  modelConfigKey?: string | undefined;
  /**
   * List of tools to use for this variation. The latest version of the tool will be used.
   */
  tools?: Array<VariationToolPost> | undefined;
  /**
   * List of tool keys to use for this variation. The latest version of the tool will be used.
   */
  toolKeys?: Array<string> | undefined;
  judgeConfiguration?: JudgeConfiguration | undefined;
};

/** @internal */
export const AIConfigVariationPostModel$inboundSchema: z.ZodType<
  AIConfigVariationPostModel,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AIConfigVariationPostModel$Outbound = {};

/** @internal */
export const AIConfigVariationPostModel$outboundSchema: z.ZodType<
  AIConfigVariationPostModel$Outbound,
  z.ZodTypeDef,
  AIConfigVariationPostModel
> = z.object({});

export function aiConfigVariationPostModelToJSON(
  aiConfigVariationPostModel: AIConfigVariationPostModel,
): string {
  return JSON.stringify(
    AIConfigVariationPostModel$outboundSchema.parse(aiConfigVariationPostModel),
  );
}
export function aiConfigVariationPostModelFromJSON(
  jsonString: string,
): SafeParseResult<AIConfigVariationPostModel, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AIConfigVariationPostModel$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIConfigVariationPostModel' from JSON`,
  );
}

/** @internal */
export const AIConfigVariationPost$inboundSchema: z.ZodType<
  AIConfigVariationPost,
  z.ZodTypeDef,
  unknown
> = z.object({
  comment: z.string().optional(),
  description: z.string().optional(),
  instructions: z.string().optional(),
  key: z.string(),
  messages: z.array(Message$inboundSchema).optional(),
  model: z.lazy(() => AIConfigVariationPostModel$inboundSchema).optional(),
  name: z.string(),
  modelConfigKey: z.string().optional(),
  tools: z.array(VariationToolPost$inboundSchema).optional(),
  toolKeys: z.array(z.string()).optional(),
  judgeConfiguration: JudgeConfiguration$inboundSchema.optional(),
});
/** @internal */
export type AIConfigVariationPost$Outbound = {
  comment?: string | undefined;
  description?: string | undefined;
  instructions?: string | undefined;
  key: string;
  messages?: Array<Message$Outbound> | undefined;
  model?: AIConfigVariationPostModel$Outbound | undefined;
  name: string;
  modelConfigKey?: string | undefined;
  tools?: Array<VariationToolPost$Outbound> | undefined;
  toolKeys?: Array<string> | undefined;
  judgeConfiguration?: JudgeConfiguration$Outbound | undefined;
};

/** @internal */
export const AIConfigVariationPost$outboundSchema: z.ZodType<
  AIConfigVariationPost$Outbound,
  z.ZodTypeDef,
  AIConfigVariationPost
> = z.object({
  comment: z.string().optional(),
  description: z.string().optional(),
  instructions: z.string().optional(),
  key: z.string(),
  messages: z.array(Message$outboundSchema).optional(),
  model: z.lazy(() => AIConfigVariationPostModel$outboundSchema).optional(),
  name: z.string(),
  modelConfigKey: z.string().optional(),
  tools: z.array(VariationToolPost$outboundSchema).optional(),
  toolKeys: z.array(z.string()).optional(),
  judgeConfiguration: JudgeConfiguration$outboundSchema.optional(),
});

export function aiConfigVariationPostToJSON(
  aiConfigVariationPost: AIConfigVariationPost,
): string {
  return JSON.stringify(
    AIConfigVariationPost$outboundSchema.parse(aiConfigVariationPost),
  );
}
export function aiConfigVariationPostFromJSON(
  jsonString: string,
): SafeParseResult<AIConfigVariationPost, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AIConfigVariationPost$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIConfigVariationPost' from JSON`,
  );
}
